/* eslint-disable react-hooks/exhaustive-deps */
import 'animate.css';
import LinkButton from 'components/shared/button/LinkButton';
import GNEModal from 'components/shared/modal/Modal';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  ACCOUNT_TYPE,
  CONFIGURE_VIEW,
  PRIORITY_ADD_SUCCESS_MSG,
  PRIORITY_TABLE_COLUMNS,
  PRIORITY_TYPE,
} from 'constants/constants';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  addPriority,
  deleteAccount,
} from 'services/configure-priority.service';
import { getCustomerData } from 'store/customer/customer-view-actions';
import {
  setAdvanceSearchSelectedData,
  setIsApply,
  setPriorityCustomers,
  setSelectedCustomer,
} from 'store/customer/customerViewSlice';
import { setCards, setDefaultCard } from 'store/home/homeMyViewSlice';
import Confirmation from '../../shared/confirmation/Confirmation';
import AdvanceSearch from '../../shared/customer/AdvanceSearch';
import CustomerDropdown from '../../shared/customer/CustomerDropdown';
import { getArrayToStringArray } from 'utils/utils';

const MyPriority = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCheckboxOption, setSelectedCheckboxOption] = useState(
    ACCOUNT_TYPE.account
  );
  const userRestrictedEcosystemt = useSelector(
    (state) => state?.Auth?.userRestrictedEcosystemt
  );
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);
  const [modalConfirmShow, setConfirmModalShow] = useState(false);
  const [accountId, setAccountId] = useState('');
  const [selectedOption, setSelectedOption] = useState([]);
  const advanceSearchClicked = useSelector(
    (state) => state?.CustomerView?.advanceSearchClicked
  );

  const { isApply } = useSelector((state) => state?.CustomerView);

  useEffect(() => {
    getPriorityAccountData();
    return () => {
      dispatch(setAdvanceSearchSelectedData({}));
    };
  }, [props, modalConfirmShow]);

  const getPriorityAccountData = async () => {
    await getData();
  };
  const handleNewCustomerClick = () => {
    setSelectedCheckboxOption(ACCOUNT_TYPE.account);
    dispatch(setSelectedCustomer([]));
    setShowModal(true);
  };

  const handleDelete = (record) => {
    setAccountId(record.value);
    setConfirmModalShow(true);
  };

  const onHide = () => {
    setConfirmModalShow(false);
  };

  const onDelete = async (customerId) => {
    try {
      const response = await deleteAccount(customerId, unixId, roleId);
      let updatedMyPriorityData = [];
      if (response) {
        updatedMyPriorityData = data.filter(
          (item) => item.customerId !== customerId
        );
        setData(updatedMyPriorityData);
        dispatch(setDefaultCard([]));
        dispatch(setCards([]));
      }
    } catch (err) {
      console.log(err.message);
    }
    setConfirmModalShow(false);
  };

  /**
   * Get all the priority accounts for the use
   * TODO: use the correct service, this is a temporary call
   */
  const getData = async () => {
    const ecosystems = getArrayToStringArray(userRestrictedEcosystemt);
    const result = await getCustomerData(
      true,
      '',
      0,
      false,
      ecosystems,
      [],
      undefined,
      undefined,
      undefined,
      true
    );
    setData(result.result.data);
    dispatch(setPriorityCustomers(result.result.data));
  };

  const handleCancel = () => {
    setShowModal(false);
    setSelectedOption([]);
  };

  const handleSaveNew = async () => {
    const payload = {
      customerId: selectedOption?.value,
      primaryFlag: 'N',
      squad: null,
      page: PRIORITY_TYPE.MY_PRIORITY,
    };
    let isNewCustomer = data.some((acc) => acc.value === selectedOption?.value);

    if (isNewCustomer === false) {
      if (selectedOption?.label === undefined) {
        toast.warn('Please select ' + selectedCheckboxOption + ' in  dropdown');
      } else {
        await addPriority(payload);
        toast.success(`${selectedOption?.label} ${PRIORITY_ADD_SUCCESS_MSG}`);
        getPriorityAccountData();
      }
    } else {
      toast.error('Customer already exist');
    }
    dispatch(setSelectedCustomer([]));
    setSelectedOption([]);
    dispatch(setDefaultCard([]));
    dispatch(setCards([]));
  };
  const handleSaveClose = async () => {
    dispatch(setIsApply(!isApply));
    const payload = {
      customerId: selectedOption?.value,
      primaryFlag: 'N',
      squad: null,
      page: PRIORITY_TYPE.MY_PRIORITY,
    };

    try {
      let isNewCustomer = data.some(
        (acc) => acc.value === selectedOption?.value
      );

      if (isNewCustomer === false) {
        if (selectedOption?.label !== undefined) {
          await addPriority(payload);
          toast.success(`${selectedOption?.label} ${PRIORITY_ADD_SUCCESS_MSG}`);
          getPriorityAccountData();
        }
      } else {
        toast.error('Customer already exist');
      }
    } catch (error) {
      console.log('error', error);
    }
    setShowModal(false);
    //setSelectedOption([]);
    dispatch(setDefaultCard([]));
    dispatch(setCards([]));
  };

  const onChangeHandler = async (customer) => {
    dispatch(setSelectedCustomer(customer));
    setSelectedOption(customer);
  };
  const size = { x: 1100, y: 400 };

  // html modal title
  const title = (
    <>
      <p
        className='title__large title__bold d-flex align-items-center'
        title='Add New Customer title'>
        <i className='icon icon__add-big'></i>Add New Customer
      </p>
      <p
        className='text text__small'
        title='Sub title'>
        Search for account, site, parent payer, or payer below.
      </p>
    </>
  );

  // html modal content
  const content = (
    <div className='mb-4'>
      <CustomerDropdown
        page={CONFIGURE_VIEW.configurePriority}
        onChangeHandler={onChangeHandler}
        focusDisabled={true}
        focusChecked={false}
        isDisabled={false}
      />

      {advanceSearchClicked[CONFIGURE_VIEW.configurePriority] && (
        <div className='animate__animated animate__fadeIn search-container addCustomerView'>
          <AdvanceSearch
            page={CONFIGURE_VIEW.configurePriority}
            viewType={CONFIGURE_VIEW.configurePriority}
          />
        </div>
      )}
    </div>
  );

  // html modal footer
  const footer = (
    <div className='d-flex justify-content-end w-100'>
      <LinkButton
        className='text text__small'
        onClick={handleCancel}>
        Cancel
      </LinkButton>
      <Button
        variant='btn btn-gne btn-outline-primary btn-gne__outline'
        onClick={handleSaveNew}
        className='text__small ms-3'>
        Save and New
      </Button>
      <Button
        variant='btn btn-gne btn-primary'
        onClick={handleSaveClose}
        className='text__small ms-3'>
        Save and Close
      </Button>
    </div>
  );

  return (
    <>
      <div className='d-flex justify-content-between align-items-start mb-3'>
        <div className='d-flex align-items-start me-md-3'>
          <i className='icon icon__info_icon-yellow me-2 mt-4 flex-shrink-0' />
          <p className='text text__bold mb-0'>
            Setting a customer as a priority designates you as their Point of
            Contact (POC), enabling closer collaboration with the account team.
            Priority Accounts or Sites can only be selected if they have a
            footprint in your aligned ecosystems. In contrast, any Parent Payer
            or Payer can be set as a priority customer, regardless of ecosystem
            alignment.
          </p>
        </div>
        <Button
          variant='btn btn-gne btn-outline-primary btn-gne__outline btn-gne__outline--add'
          onClick={handleNewCustomerClick}
          className='flex-shrink-0'>
          Add New Customer
        </Button>
      </div>

      {/* table */}
      <ConfigurableTable
        rows={data}
        columns={PRIORITY_TABLE_COLUMNS}
        expandRowByClick={false}
        enableColumnSelection={false}
        enableExport={false}
        showActionIcon={true}
        iconProps={{ iconCss: 'delete' }}
        onActionClickHandler={handleDelete}
        tableName='myPriority'
        isGlobalSort={false}
        pagination={false}
        basicSort={true}
        dimentions={size}
      />

      {/* add modal */}
      <GNEModal
        titlecontent={title}
        show={showModal}
        onHide={handleCancel}
        content={content}
        css='size-medium'
        footer={footer}
        backdrop='static'
      />
      <Confirmation
        show={modalConfirmShow}
        onOK={() => onDelete(accountId)}
        onHide={onHide}
      />
    </>
  );
};

export default MyPriority;
